// __APP_VERSION__ is defined with WebPack’s DefinePlugin
// eslint-disable-next-line no-undef
export default (): string => __APP_VERSION__
